import { createContext, useContext, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import DEFAULTS from "@/lib/contentDefaults.json";

export { SeoHead, normPath } from "@/lib/seoHead";

const PRESETS = { registrazione: "/registrazione", accedi: "/accedi", assessment: "/assessment", profilo: "/profilo", home: "/", privacy: "/informativa-privacy", accessibilita: "/accessibilita" };
const Ctx = createContext({ ...DEFAULTS, reload: () => {} });
const BACKEND = process.env.REACT_APP_BACKEND_URL;

export const imgSrc = (url) => (url?.startsWith("/api/") ? `${BACKEND}${url}` : url);

const setIcons = (url) => {
    ["icon", "apple-touch-icon"].forEach((rel) => {
        let el = document.head.querySelector(`link[rel="${rel}"]`);
        if (!el) { el = document.createElement("link"); el.rel = rel; document.head.appendChild(el); }
        el.type = "image/png";
        el.href = imgSrc(url);
    });
};

export const ContentProvider = ({ children }) => {
    const [state, setState] = useState(null);
    const load = () => api.get("/content").then(({ data }) => setState(data)).catch(() => setState((s) => s || DEFAULTS));
    useEffect(() => {
        load();
        const t = setTimeout(() => setState((s) => s || DEFAULTS), 2500);
        return () => clearTimeout(t);
    }, []);
    useEffect(() => { if (state) setIcons(state.images.favicon.url); }, [state]);
    if (!state) return <div aria-busy="true" className="min-h-screen" data-testid="content-loading" />;
    return <Ctx.Provider value={{ ...state, reload: load }}>{children}</Ctx.Provider>;
};

export const useContent = () => useContext(Ctx);

export const useText = () => {
    const { texts } = useContent();
    return (key) => texts[key] ?? DEFAULTS.texts[key] ?? "";
};

export const CtaLink = ({ cta, className, testId, onClick }) => {
    if (cta.target === "esterno") {
        const nt = cta.new_tab;
        return (
            <a href={cta.url} className={className} data-testid={testId} onClick={onClick} {...(nt ? { target: "_blank", rel: "noopener noreferrer" } : { rel: "noopener" })}>
                {cta.text}{nt && <span className="sr-only"> (si apre in una nuova scheda)</span>}
            </a>
        );
    }
    return <Link to={PRESETS[cta.target] || "/"} className={className} data-testid={testId} onClick={onClick}>{cta.text}</Link>;
};
